enum ApiSecretStatus {
    Active = 'Active',
    Expired = 'Expired',
    ExpiresSoon = 'ExpiresSoon',
}

export default ApiSecretStatus;
